module.exports = __webpack_public_path__ + "img/logo-kkpoints-255-wt@3x.bc559418.png";